import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import poweredByToggle from 'public/images/powered-by-toggle.png';
import poweredByToggleCompact from 'public/images/powered-by-toggle-compact.png';
import React from 'react';

import { config } from '@/config/app.config';
import { useTouchDevice } from '@/stores/MediaQueryStore';

import * as S from './ChartFooter.styles';

export const ChartFooter = () => {
  const { t } = useTranslation(['common', 'earnings']);
  const isTouchDevice = useTouchDevice();

  return (
    <S.ChartFooterRoot>
      <S.FooterItem>{t('earnings:chart.helpText')}</S.FooterItem>
      <S.FooterItem>
        <a
          href={config.urls.website}
          title={t('common:goToMainWebsitePage')}
          target="_blank"
          rel="noreferrer"
        >
          {isTouchDevice ? (
            <Image
              width="62"
              height="18"
              src={poweredByToggleCompact}
              alt={t('common:poweredByToggleAlt')}
            />
          ) : (
            <Image
              src={poweredByToggle}
              width="138"
              height="12"
              alt={t('common:poweredByToggleAlt')}
            />
          )}
        </a>
      </S.FooterItem>
    </S.ChartFooterRoot>
  );
};
